export enum CrossSellingRequestType {
  CART = "CART",
  PAYMENT = "PAYMENT",
  ASSISTANCE = "ASSISTANCE",
  ACCOUNT_ASSISTANCE = "ACCOUNT_ASSISTANCE"
}
